import React, {Component} from "react";
import {cx} from "../../lib/ClassSet";
import {connect} from "react-redux";
import {removeWindow, focusWindow} from "../../actions/WindowActions";
import Button from "../Button";
import "./Window.scss";

class Window extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dragging: false,
      resizing: false,
      hasPositioning: false,
      originX: 0,
      originY: 0,
      oldW: 0,
      oldH: 0,
      width: 0,
      height: 0,
      x: 0,
      y: 0,
    }
  }

  componentDidMount() {
    this.moveListener = window.addEventListener("mousemove", this.handleDrag.bind(this));
    this.releaseListener = window.addEventListener("mouseup", this.handleMouseUp.bind(this)); 
  }

  componentWillUnmount() {
    window.removeEventListener("mousemove", this.moveListener);
    window.removeEventListener("mouseup", this.releaseListener);
  }

  render() {
    let styles = {
      zIndex: this.props.index
    }

    let classes = cx({
      "Window": true,
      "s-positioning": this.state.hasPositioning,
      "s-focused": this.props.focused
      // "s-active": this.props.active,
      // "s-inactive": !this.props.active,
    })

    if (this.state.hasPositioning) {
      styles.left = this.state.x;
      styles.top = this.state.y;
      styles.width = this.state.width;
      styles.height = this.state.height;
    }

    return (
      <div ref="window" className={classes} style={styles} onMouseDownCapture={this.handleWindowClick.bind(this)}>
        <div className="header" onMouseDown={this.handleMouseDown.bind(this)}>
          <div className="title">{this.props.title}</div>
          <div className="buttons">
            <Button label="Close" link={true} onClick={this.handleClose.bind(this)} />
          </div>
        </div>
        <div className="content">
          {this.props.children}
        </div>
        <div className="resize" onMouseDown={this.handleResize.bind(this)}>
          <div className="icon" />
        </div>
      </div>
    );
  }

  handleWindowClick(e) {
    if (!this.props.focused) {
      this.props.focusWindow(this.props.windowId);
    }
  }

  handleMouseDown(e) {
    let rect = this.refs.window.getBoundingClientRect();
    e.preventDefault();
    this.setState({
      dragging: true,
      resizing: false,
      hasPositioning: true,
      originX: e.clientX,
      originY: e.clientY,
      width: rect.width,
      height: rect.height,
      oldX: rect.x,
      oldY: rect.y,
      x: rect.x,
      y: rect.y
    })
  }

  handleResize(e) {
    let rect = this.refs.window.getBoundingClientRect();
    e.preventDefault();
    this.setState({
      dragging: false,
      resizing: true,
      hasPositioning: true,
      originX: e.clientX,
      originY: e.clientY,
      oldW: rect.width,
      oldH: rect.height,
      width: rect.width,
      height: rect.height,
      x: rect.x,
      y: rect.y      
    })    
  }

  handleMouseUp(e) {
    if (!this.state.dragging && !this.state.resizing) return;
    this.setState({
      dragging: false,
      resizing: false
    })
  }

  handleDrag(e) {
    if (this.state.dragging) {
      let diffX = e.clientX - this.state.originX;
      let diffY = e.clientY - this.state.originY;
      this.setState({
        x: Math.round(Math.max(this.state.oldX + diffX, 0)),
        y: Math.round(Math.max(this.state.oldY + diffY, 0))
      })
    } else if (this.state.resizing) {
      let diffX = e.clientX - this.state.originX;
      let diffY = e.clientY - this.state.originY;
      this.setState({
        width: Math.round(Math.max(this.state.oldW + diffX, 270)),
        height: Math.round(Math.max(this.state.oldH + diffY, 160))
      })      
    }
  }

  handleClose() {
    this.props.removeWindow(this.props.windowId);
  }

}

Window.defaultProps = {
  title: "Window",
  index: 0, // zIndex so we know how to stack em.
  active: true,
  modal: false,
  options: {}
}

export default connect(null, {removeWindow, focusWindow})(Window);